import PropTypes from 'prop-types';
import { format } from 'date-fns';
import {
  Avatar,
  Box,
  Card,
  Checkbox,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import { Scrollbar } from 'src/components/scrollbar';
import { getInitials } from 'src/utils/get-initials';
import { useState } from 'react';
import CustomerDetail from 'src/pages/customer/customer-detail';
import ConfirmDialog from 'src/pages/rider/ConfirmDialog';
import dashboardService from 'src/services/dashboardService';
import { useNavigate } from 'react-router-dom';

export const CustomersTable = (props) => {

  const {
    count = 0,
    items = [],
    onDeselectAll,
    onDeselectOne,
    onPageChange = () => { },
    onRowsPerPageChange,
    onSelectAll,
    onSelectOne,
    page = 0,
    rowsPerPage = 0,
    selected = []
   } = props;
  
  const selectedSome = (selected.length > 0) && (selected.length < items.length);
  const selectedAll = (items.length > 0) && (selected.length === items.length);
  const router = useNavigate();
  const [customerId, setCusomerId] = useState();
  const [isCustomerViewOpen, setIsCustomerViewOpen] = useState(false);
  const [isYesNoDialogOpen, setIsYesNoDialogOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const custsomerDetail = (customerId) => {
    setCusomerId(customerId);
    setIsCustomerViewOpen(!isCustomerViewOpen);


  }
  const deleteCustomer = (customerId) => {
    setCusomerId(customerId);
    setIsYesNoDialogOpen(!isYesNoDialogOpen);

    // router.push(`customer/customer-detail?customerId=${customerId}`);
  }

  const deleteUser = () => {
    dashboardService.deleteCustomer(customerId).then((res) => {
      if (res.status == 200) {
        setSuccessMessage(res.data.message);
        window.location.reload();
      }
    })
  }
  return (
    <Card>
      <>
        < >
          <Table>
            <TableHead>
              <TableRow>
              <TableCell>
                  S.N
                </TableCell>
                <TableCell>
                  Name
                </TableCell>
                <TableCell>
                  Email
                </TableCell>
                <TableCell>
                  Location
                </TableCell>
                <TableCell>
                  Phone
                </TableCell>
                <TableCell>
                  Signed Up
                </TableCell>
                <TableCell>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((customer, index) => {
                const isSelected = selected.includes(customer.id);
                const createdAt = format(new Date(customer.created_at), 'dd/MM/yyyy');
                return (
                  <TableRow
                    hover
                    key={customer.id}
                    selected={isSelected}
                  >
                   <TableCell>
                     {index+1}
                    </TableCell>
                    <TableCell>
                      <Stack
                        alignItems="center"
                        direction="row"
                        spacing={2}
                      >
                        <Avatar src={customer.avatar}>
                          {getInitials(customer.full_name)}
                        </Avatar>
                        <Typography variant="subtitle2">
                          {customer.full_name}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      {customer.email}
                    </TableCell>
                    <TableCell>
                      {customer.address}
                    </TableCell>
                    <TableCell>
                      {customer.phone_number}
                    </TableCell>
                    <TableCell>
                      {createdAt}
                    </TableCell>
                    <TableCell>
                      <div className="flex">
                        <button
                          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded mr-2"
                          onClick={() => custsomerDetail(customer.id)}
                        >
                          View
                        </button>
                        <button
                          className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded mr-2"
                          onClick={() => deleteCustomer(customer.id)}
                        >
                          Delete
                        </button>

                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </>
      </>

      {
        isCustomerViewOpen && (
          <CustomerDetail customerId={customerId} isOpen={isCustomerViewOpen} onClose={custsomerDetail} />
        )
      }
      {
        isYesNoDialogOpen && (
          <ConfirmDialog isOpen={isYesNoDialogOpen} onYes={deleteUser} onNo={deleteCustomer} message={"Are you sure you want to  delete this user?"} />
        )
      }
    </Card>
  );
};

CustomersTable.propTypes = {
  count: PropTypes.number,
  items: PropTypes.array,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array
};
